import { CertificatesRoutes } from "./certificates.routes";
import { CommunicationSettingsRoutes } from "./communication-settings.routes";
import { DashboardRoutes } from "./dashboard.routes";
import { DebugRoutes } from "./debug.routes";
import { LearnStateRoutes } from "./learn-state.routes";
import { LearnRoutes } from "./learn.routes";
import { LearningAchievementsRoutes } from "./learning-achievements.routes";
import { LegalRoutes } from "./legal.routes";
import { MessagingRoutes } from "./messaging.routes";
import { NodesRoutes } from "./nodes.routes";
import { PageNotFoundRoutes } from "./page-not-found.routes";
import { SearchRoutes } from "./search.routes";
import { ServerErrorRoutes } from "./server-error.routes";
import { FaqRoutes } from "../../../../app/screens/frequently-asked-question-screen/frequently-asked-question.path";
import { PrivateRouteDefinition } from "../../../../infecto-lms-webapp/router/interfaces";
import { LandingPagesRoutes } from "../non-auth/landing-pages.routes";

export const ImplAuthRoutes: PrivateRouteDefinition[] = [
	...DashboardRoutes,
	...LearnRoutes,
	...NodesRoutes,
	...SearchRoutes,
	...CommunicationSettingsRoutes,
	...DebugRoutes,
	...LearnStateRoutes,
	...LegalRoutes,
	...MessagingRoutes,
	...LandingPagesRoutes,
	...CertificatesRoutes,
	...PageNotFoundRoutes,
	...ServerErrorRoutes,
	...LearningAchievementsRoutes,
	...FaqRoutes,
];
